import Gigya, { BaseParams } from './gigya.js'

export type GetAuthMethodsParams = {
	identifierType: 'username' | 'email' | 'emailOrUsername'
	identifier: string
	aToken?: string
}

export type GetAuthMethodsResponse = {
	methods: Array<
		'password' | 'push' | 'emailOtp' | 'magicLink' | 'phoneOtp' | 'passkeyRegister' | 'passkeyLogin'
	>
}

export class Auth {
	constructor(protected gigya: Gigya) {}

	public getMethods(params: BaseParams & GetAuthMethodsParams) {
		return this.gigya.request<GetAuthMethodsResponse>('accounts.auth.getMethods', params)
	}
}
